import React from "react";
import DisclaimerModal from "./DisclaimerModal";
import { ErrorType } from "const";

function NoneHnwContactBranch(modalProps) {
  return (
    <DisclaimerModal
      {...modalProps}
      key={ErrorType.NONE_HNW_CONTACT_BRANCH}
      title="modal.disclaimer.header.hnw"
      message={ErrorType.NONE_HNW_CONTACT_BRANCH}
      rejectLabel="global.close"
      visible={modalProps.code === ErrorType.NONE_HNW_CONTACT_BRANCH}
      useAccept={false}
      isError
    />
  );
}

export default NoneHnwContactBranch;
